import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import ModalContent from './modalContent';

const getAddReferencesWithZeroModalActions = (props) => {
  const { selectedSupplierProducts, handleAddReferencesWithZero, resetAddReferencesWithZeroModal } =
    props;

  const selectedSupplierProductIds = selectedSupplierProducts.map(({ id }) => id);

  return [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      handleClick: () => {
        handleAddReferencesWithZero(selectedSupplierProductIds);
        resetAddReferencesWithZeroModal();
      },
      isDisabled: !selectedSupplierProducts.length,
    },
  ];
};

export const getAddReferencesWithZeroModalConfig = (props) => {
  const { resetAddReferencesWithZeroModal } = props;

  const params = {
    type: 'action',
    width: '542px',
    height: 'auto',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    title: i18next.t('STOCKS.STOCKS.LIST_ADD_REFERENCES_WITH_ZERO'),
    handleCloseCleanUp: resetAddReferencesWithZeroModal,
    actions: getAddReferencesWithZeroModalActions(props),
    component: ModalContent,
    data: props,
  };

  return params;
};
